<template>
  <div class="space-y-8">
    <div>
      <LinkedContactList :account-id="accountId" />
    </div>
  </div>
</template>

<script>
import LinkedContactList from './linkedContacts/components/LinkedContactList.vue';

export default {
  components: {
    LinkedContactList,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
};
</script>
